<p-button *ngIf="showClearButton && filterActive" size="small" label="limpar filtros" [link]="true" (click)="clear()" />
<ng-content></ng-content>
